import DeliveryAddress from './DeliveryAddress'
import './DeliveryAddress.css'

export default DeliveryAddress


// WEBPACK FOOTER //
// ./src/features/OrderDetails/components/DeliveryAddress/index.js